import React from 'react'
// import about from '../assets/images/1.png'
import { Link } from 'react-router-dom'

import about1 from '../assets/images/about/1.jpg'
import about2 from '../assets/images/about/2.jpg'
import about3 from '../assets/images/about/3.jpg'
import about4 from '../assets/images/about/4.jpg'
import VideoOne from './video-one'

export default function AboutOne() {
  return (
    <>
    <div className="row g-4 align-items-center">
        <div className="row align-items-center">
            <div className="col-lg-5 col-md-6">
                <div className="position-relative">
                    <div className="row align-items-end">
                        <div className="col-7">
                            <img src={about1} className="img-fluid rounded" alt=""/>
                        </div>

                        <div className="col-5">
                            <img src={about3} className="img-fluid rounded" alt=""/>
                        </div>
                    </div>

                    <div className="row align-items-start mt-4">
                        <div className="col-5">
                            <img src={about4} className="img-fluid rounded" alt=""/>
                        </div>

                        <div className="col-7">
                            <img src={about2} className="img-fluid rounded" alt=""/>
                        </div>
                    </div>

                    <VideoOne/>

                    <div className="position-absolute top-50 start-50 translate-middle z-n1">
                        <div className="bg-primary rounded opacity-75 p-5"><div className="p-5 m-5"></div></div>
                    </div>
                </div>
            </div>

            <div className="col-lg-7 col-md-6 mt-4 mt-md-0 pt-2 pt-md-0">
                <div className="section-title ms-lg-5">
                    <h6 className="text-primary text-uppercase">About Eloza</h6>
                    <h4 className="title mb-3">Convert more visitors <br/> into customers.</h4>

                    <p className="text-muted para-desc mb-0">Design better and spend less time without restricting creative freedom. Combine layouts, customize everything.</p>
                
                    <ul className="list-unstyled text-muted mb-0 mt-3">
                        <li className="mb-1"><span className="text-primary h5 me-2"><i className="mdi mdi-check-circle-outline align-middle"></i></span>Digital Marketing Solutions for Tomorrow</li>
                        <li className="mb-1"><span className="text-primary h5 me-2"><i className="mdi mdi-check-circle-outline align-middle"></i></span>Our Talented & Experienced Marketing Agency</li>
                        <li className="mb-1"><span className="text-primary h5 me-2"><i className="mdi mdi-check-circle-outline align-middle"></i></span>Create your own skin to match your brand</li>
                    </ul>

                    <div className="mt-4">
                        <Link to="/aboutus" className="btn btn-soft-primary">About Us <i className="mdi mdi-arrow-right align-middle"></i></Link>
                    </div>
                </div>
            </div>
        </div>
    </div> 
    </>
  )
}
